var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPeople48Filled = function SvgIconPeople48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.952 25a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM33.65 31.35a5 5 0 0 0-5-5H13.3a5 5 0 0 0-5 5v5h25.4l-.05-5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29.83 24.39-1.36-3.11a3.8 3.8 0 0 0 0-7l1.36-3.12a7.19 7.19 0 0 1 0 13.19v.04ZM39.651 36.299h-3.35v-5a1.6 1.6 0 0 0-1.6-1.6v-3.4a5 5 0 0 1 5 5l-.05 5Z",
    fill: "current"
  })));
};
export default SvgIconPeople48Filled;